import { defineMessages } from 'react-intl';

import { Switch } from '#src/atoms/inputs/Switch/index.tsx';
import { SettingsSection } from '#src/components/settings/SettingsSection/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { LIFECYCLE, useLifecycle } from '#src/hooks/useLifecycle.ts';
import { fantasy } from '#src/lib/glossary.ts';

const messages = defineMessages({
  description: {
    defaultMessage: 'Apply market credits by default when buying cards.',
  },
});

export const DisableConversionCreditPreselection = () => {
  const { currentUser } = useCurrentUserContext();
  const { update, lifecycle } = useLifecycle();
  const unselect =
    lifecycle?.unselectConversionCreditByDefaultFromSettings || false;

  if (!currentUser) return null;

  return (
    <SettingsSection
      title={fantasy.credits}
      description={messages.description}
      toggleButton={
        <Switch
          checked={!unselect}
          onChange={() => {
            update(
              LIFECYCLE.unselectConversionCreditByDefaultFromSettings,
              !unselect
            );
          }}
        />
      }
    />
  );
};
